import { render, staticRenderFns } from "./edit-custom-luts.vue?vue&type=template&id=3253355a&scoped=true&"
import script from "./edit-custom-luts.vue?vue&type=script&lang=js&"
export * from "./edit-custom-luts.vue?vue&type=script&lang=js&"
import style0 from "./edit-custom-luts.vue?vue&type=style&index=0&id=3253355a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253355a",
  null
  
)

export default component.exports